import { render } from "./HostUpdate.vue?vue&type=template&id=f0773af6&scoped=true"
import script from "./HostUpdate.vue?vue&type=script&lang=js"
export * from "./HostUpdate.vue?vue&type=script&lang=js"

import "./HostUpdate.vue?vue&type=style&index=0&id=f0773af6&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder@2/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0773af6"]])

export default __exports__